import React from 'react';
import PropTypes from 'prop-types';
import { strings } from '../../../localization';

export default class SafetyScoreLandingPage extends React.PureComponent {

    static propTypes = {
        allScoreFactorsAreValid: PropTypes.bool.isRequired,
        onOptionsClick: PropTypes.func.isRequired,
        onLoadScoreClick: PropTypes.func.isRequired
    };

    render() {
        return (
            <div className="safety-score-landing-page">
                <div className="safety-score-vertically-centered">

                    <h2>{strings.score_header}</h2>

                    <h6>{strings.score_how_to_description}</h6>

                    <div className="score-options-main-actions">

                        <button className="btn btn-outline-blue" onClick={this.props.onOptionsClick}>
                            {strings.action_options}
                        </button>

                        <button
                            className="btn btn-blue"
                            onClick={this.props.onLoadScoreClick}
                            disabled={!this.props.allScoreFactorsAreValid}
                        >
                            {strings.action_load_score}
                        </button>

                    </div>
                </div>
            </div>
        );
    }
}